// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--QESQ5";
export var modal_content = "modal-module--modal_content--1wbYk";
export var modal_top = "modal-module--modal_top--nqA3w";
export var title = "modal-module--title--an5Nl";
export var overlay = "modal-module--overlay--VGPID";
export var close_icon = "modal-module--close_icon--Hjadi";